export default "__VITE_ASSET__CsAcqSYb__"